module.exports = __webpack_public_path__ + "static/media/rse.0d35d0e2.gif";